(() => {
  'use strict';
  const form=document.getElementById('preview-product-form');
  const buy=form?.querySelector('[data-native-buy]');
  const error=form?.querySelector('[data-buy-error]');
  const initialId=form?.elements.namedItem('id')?.value,initiallyDisabled=buy?.disabled;
  const routeRoot=window.Shopify?.routes?.root || '/';
  const cartUrl=new URL(routeRoot+'cart.js',location.origin);
  let generation=0,pending=false,locked=false;
  function paint(cart){
    if(!Number.isSafeInteger(cart?.item_count)||cart.item_count<0)throw Error('Invalid cart count');
    document.querySelectorAll('[data-cart-count]').forEach(n=>{
      n.textContent=String(cart.item_count);
      const a=n.closest('a');if(!a)return;
      a.dataset.countLabel ||= a.getAttribute('aria-label') || 'Cart';
      a.setAttribute('aria-label',a.dataset.countLabel+' ('+cart.item_count+')');
    });
  }
  async function refresh(){
    const current=++generation;
    const response=await fetch(cartUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(8000)});
    if(!response.ok)throw Error('Cart unavailable');
    const cart=await response.json();
    if(current===generation)paint(cart);
    return cart;
  }
  const sync=()=>{refresh().catch(()=>{});};
  function reset(){
    if(!buy)return;
    pending=false;locked=false;form.removeAttribute('aria-busy');
    const id=form.elements.namedItem('id')?.value;
    let variants=[];try{variants=JSON.parse(document.getElementById('preview-variants')?.textContent||'[]');}catch{}
    buy.disabled=String(id)===String(initialId)?initiallyDisabled:variants.find(v=>String(v.id)===String(id))?.available===false;
  }
  window.addEventListener('pageshow',()=>{reset();sync();});
  window.addEventListener('focus',sync);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync();});
  ['cart:updated','cart:refresh','cart:change'].forEach(name=>document.addEventListener(name,sync));
  window.addEventListener('storage',e=>{if(e.key==='monaco_cart_changed')sync();});
  if(form&&buy&&error)form.addEventListener('submit',async event=>{
    event.preventDefault();event.stopImmediatePropagation();
    if(pending||locked||buy.disabled||!form.checkValidity())return;
    pending=true;buy.disabled=true;form.setAttribute('aria-busy','true');error.hidden=true;
    ++generation;
    const body=new FormData(form);body.delete('return_to');
    const action=new URL(form.action,location.href);action.pathname=action.pathname.replace(/\/?$/,'')+'.js';
    let response;
    try {
      response=await fetch(action,{method:'POST',body,credentials:'same-origin',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
      if(!response.ok){
        await refresh().catch(()=>{});
        if(response.status>=500)throw Error('Uncertain addition');
        let detail;try{detail=await response.json();}catch{}
        error.textContent=typeof detail?.description==='string'?detail.description:error.dataset.rejected;
        error.hidden=false;reset();return;
      }
      locked=true;
      await refresh().catch(()=>{});
      try{localStorage.setItem('monaco_cart_changed',String(Date.now()));}catch{}
      const checkout=new URL(form.elements.namedItem('return_to')?.value||routeRoot+'checkout',location.origin);
      if(checkout.origin!==location.origin)throw Error('Invalid checkout destination');
      location.assign(checkout.href);
    } catch {
      locked=true;await refresh().catch(()=>{});
      error.textContent=error.dataset.uncertain;error.hidden=false;
    } finally {pending=false;form.removeAttribute('aria-busy');}
  },true);
  sync();
})();
